/**
 * @ngdoc controller
 * @name adjust.accountSettings.controller:AccountAddonsPackagesController
 *
 * @description
 * Account history tab
 *
 */
function AccountAddonsPackagesController($scope) {
  'ngInject';

  $scope.$emit('account-settings:active', 'addons-packages');
}

export { AccountAddonsPackagesController };
